module.exports = __webpack_public_path__ + "img/donatella-araujo-byn.350d3a14.png";